var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessToast = function SvgSuccessToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4321",
    transform: "translate(4999.671 17819.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#baffd2",
    "data-name": "Rectangle 2416",
    rx: 10,
    transform: "translate(-4999.671 -17819.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0eb948",
    fillRule: "evenodd",
    d: "M-4979.843-17810.39a1.214 1.214 0 0 1 .227 1.7l-6.021 7.895a1.21 1.21 0 0 1-1.821.121l-3.822-3.832a1.214 1.214 0 0 1 1.719-1.715l2.838 2.846 5.176-6.787a1.214 1.214 0 0 1 1.704-.228",
    "data-name": "Path 19176"
  }))));
};
export default SvgSuccessToast;